var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "seller" },
    [
      _vm.showTitle ? _c("buyerHeader") : _vm._e(),
      _c(
        "div",
        { staticClass: "clear pad30_b", class: { w1200: _vm.showTitle } },
        [
          _vm.showTitle && _vm.sellerMenuVisible
            ? _c("sellerMenu", { staticClass: "float-left mar20_r" })
            : _vm._e(),
          _c(
            "div",
            { class: { buyer_main: _vm.showTitle && _vm.sellerMenuVisible } },
            [_c("router-view")],
            1
          )
        ],
        1
      ),
      _vm.showTitle ? _c("buyerFooter") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }